import { Alert, Box, Button, Link, Stack, Typography } from '@mui/material';
import { Layout as AuthLayout } from 'layouts/auth/Layout';
import { confirmEmail } from 'store/actions/authActions';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';

const VerifyEmail = () => {
  const dispatch = useDispatch();
  const { verificationToken } = useParams();
  const { authInfo } = useSelector((store: any) => store.auth);
  useEffect(() => {
    if (verificationToken) {
      dispatch(confirmEmail({ verificationToken }));
    }
  }, [verificationToken, dispatch]);

  return (
    <AuthLayout>
      <Box
        sx={{
          backgroundColor: 'background.paper',
          flex: '1 1 auto',
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            maxWidth: 550,
            px: 3,
            py: '100px',
            width: '100%',
          }}
        >
          <div>
            <Stack spacing={1} sx={{ mb: 3 }}>
              <Typography variant='h4'>Email verification</Typography>
              {!authInfo.confirmedEmail && <Alert severity='error'>Email verification faild</Alert>}
              {authInfo.confirmedEmail && (
                <Alert severity='success'>
                  Your email has been successfully verified. Please proceed to log in.
                </Alert>
              )}
              <Link width={'100%'} href='/auth/login'>
                <Button
                  disabled={!authInfo.confirmedEmail}
                  fullWidth
                  size='large'
                  sx={{ mt: 3 }}
                  variant='contained'
                >
                  Login
                </Button>
              </Link>
            </Stack>
          </div>
        </Box>
      </Box>
    </AuthLayout>
  );
};

export default VerifyEmail;
